export default __webpack_public_path__ + "static/media/Arrival at delivery.ecbfbc39.jpg";